<div *ngIf="subCategory?._id && !searchMode" class="header-name">
    {{subCategory?.name}}
</div>

<div [ngClass]="{'search-mode': searchMode}" class="list-code-container">
    <div class="flex-row code-header">
        <div class="flex-auto flex-content-top name">
            Name
        </div>
        <div class="flex-fill flex-content-top description">
            Description
        </div>
    </div>

    <div class="list-code">
        <!-- the itemSize="90" should equal with height in css. to calculate the scrolling correctly-->
        <cdk-virtual-scroll-viewport #cdkVirtualScrollViewport itemSize="90" minBufferPx="100" maxBufferPx="100" class="list-code-viewport" (scrolledIndexChange)="onScrolledIndexChange($event)">
            <div *cdkVirtualFor="let item of codes; let even = even;" [class.even]="even" class="flex-row code-item" (click)="onClick(item)" (dblclick)="onDoubleClick(item)" [ngClass]="{'selected': item?._id === selected}">
                <div class="flex-auto flex-content-top item-name-container" #selectedItem *ngIf="item._id === selected">
                    <div class="item-name">{{item?.name}}</div>
                    <div class="type">{{item?.type}}</div>
                </div>
                <div class="flex-auto flex-content-top item-name-container" *ngIf="item._id !== selected">
                    <div class="item-name">{{item?.name}}</div>
                    <div class="type">{{item?.type}}</div>
                </div>
                <div class="item-description">
                    {{item?.description}}
                </div>
                <div class="flex-auto indicator">
                    <i class="fa fa-check"></i>
                </div>
            </div>
        </cdk-virtual-scroll-viewport>
    </div>
    <!-- HACK: fix the scroll bar lost. I don't know why -->
    <div style="height: 35px;"></div>
</div>